import React, {useReducer} from 'react';
import interfaceReducer from "./interfaceReducer";
import InterfaceContext from "./interfaceContext";

const InterfaceState = (props) => {

    const initialState = {
        change: false,
        messageError: false
    }

    const [state, dispatch] = useReducer(interfaceReducer, initialState);

    // Functions
    const changeLoadTrue = () => {
        dispatch({
            type: "CHANGETRUE"
        })
    }
    const changeLoadFalse = () => {
        dispatch({
            type: "CHANGEFALSE"
        })
    }
    const resultNegative = () => {
        dispatch({
            type: "NORESULTS"
        })
    }
    const resultNegativeTrue = () => {
        dispatch({
            type: "CHANGERESULTS"
        })
    }


    return (
        <InterfaceContext.Provider value = {{
            change: state.change,
            messageError: state.messageError,
            changeLoadTrue,
            changeLoadFalse,
            resultNegative,
            resultNegativeTrue
        }}>
            {props.children}
        </InterfaceContext.Provider>
    );
}
 
export default InterfaceState;
